import type { Terminal } from '../terminal';
import type { GameState } from '../../types/game-state';
import { getWeaponCount } from '../../engine/arsenal';
import { getTotalPopulation } from '../../engine/world-data';
import { getDefconDescription } from '../../engine/defcon';

async function runBriefing(terminal: Terminal, state: GameState): Promise<void> {
  const playerArsenal = state.playerSide === 'US' ? state.usArsenal : state.ussrArsenal;
  const enemyLabel = state.playerSide === 'US' ? 'SOVIET UNION' : 'UNITED STATES';
  const playerLabel = state.playerSide === 'US' ? 'UNITED STATES' : 'SOVIET UNION';

  const counts = getWeaponCount(playerArsenal);
  const playerPop = state.playerSide === 'US'
    ? getTotalPopulation(state.world.usCities)
    : getTotalPopulation(state.world.ussrCities);
  const enemyPop = state.playerSide === 'US'
    ? getTotalPopulation(state.world.ussrCities)
    : getTotalPopulation(state.world.usCities);

  await terminal.println('');
  await terminal.println('════════════════════════════════════════════════════════════════');
  await terminal.println('  STRATEGIC SITUATION BRIEFING', { cssClass: 'bright' });
  await terminal.println('════════════════════════════════════════════════════════════════');
  await terminal.println('');
  await terminal.println(`  DEFCON ${state.defconLevel}: ${getDefconDescription(state.defconLevel)}`);
  await terminal.println('');
  await terminal.println(`  YOU COMMAND: ${playerLabel}`);
  await terminal.println(`  OPPOSING FORCE: ${enemyLabel}`);
  await terminal.println('');
  await terminal.println('  YOUR ARSENAL:', { cssClass: 'bright' });
  await terminal.println(`    ICBM LAUNCHERS:     ${String(counts.icbm).padStart(4)}`);
  await terminal.println(`    SLBM SUBMARINES:    ${String(counts.slbm).padStart(4)}`);
  await terminal.println(`    STRATEGIC BOMBERS:  ${String(counts.bomber).padStart(4)}`);
  await terminal.println(`    TOTAL WARHEADS:     ${String(counts.warheads).padStart(4)}`);
  await terminal.println('');
  await terminal.println('  POPULATION:');
  await terminal.println(`    ${playerLabel}: ${playerPop.toLocaleString()}`);
  await terminal.println(`    ${enemyLabel}: ${enemyPop.toLocaleString()}`);
  await terminal.println('');
  await terminal.println('════════════════════════════════════════════════════════════════');
  await terminal.println('');

  await terminal.println('PRESS ANY KEY TO PROCEED TO WEAPONS ALLOCATION...', { cssClass: 'dim' });
  await terminal.waitForKey();
}

export { runBriefing };
